import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 7.625L12.9081 12.6361C12.6335 12.7912 12.3216 12.8729 12.0041 12.8729C11.6865 12.8729 11.3746 12.7912 11.1 12.6361L3 7.625M4.8 5H19.2C20.1941 5 21 5.7835 21 6.75V17.25C21 18.2165 20.1941 19 19.2 19H4.8C3.80589 19 3 18.2165 3 17.25V6.75C3 5.7835 3.80589 5 4.8 5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
